/**
 * Constants for TypeRef suffix notation that allows specifying which schema to use
 * from multi-schema references like OperationRef (which has both Request and Response schemas)
 * or ViewRef (which has InputSchemaValue and OutputSchemaValue).
 */

export class TypeRefSuffixes {
    /** Suffix to access the response/output schema from an OperationRef or similar reference */
    public static readonly Response = '.Response';

    /** Suffix to access the request/input schema from an OperationRef or similar reference */
    public static readonly Request = '.Request';

    /** Suffix to access the InputSchemaValue from a ViewRef */
    public static readonly InputSchemaValue = '.InputSchemaValue';

    /** Suffix to access the OutputSchemaValue from a ViewRef */
    public static readonly OutputSchemaValue = '.OutputSchemaValue';
}
